import React, { useState, useEffect } from "react";
import { MdOutlineCalendarMonth } from "react-icons/md";

function DateInput({ text, onClick }) {
  return (
    <div
      onClick={onClick}
      className="w-[120px] h-[30px] border-[1px] rounded-[5px] flex items-center gap-2 px-[10px] bg-white shadow-sm cursor-pointer"
    >
      <MdOutlineCalendarMonth size={18} />
      <p className="w-full text-inputEmailTitle text-[12px] font-inputEmailTitle">{text}</p>
    </div>
  );
}

export default DateInput;
